var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    baseProfile: "full",
    height: "12",
    width: "8",
    viewBox: "0 0 8 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.979v-2h2v2H6zm0-5h2v2H6v-2zm0-3h2v2H6v-2zm0-3h2v2H6v-2zm-3 9h2v2H3v-2zm0-3h2v2H3v-2zm0-3h2v2H3v-2zm0-3h2v2H3v-2zm-3 9h2v2H0v-2zm0-3h2v2H0v-2zm0-3h2v2H0v-2zm0-1.01V.979v-.01h2v2.01H0v-.01z"
  }));
};